import Phaser from "phaser";
export class BootScene extends Phaser.Scene {
  constructor() {
    super("Boot");
  }
  create(): void {
    this.cameras.main.setBackgroundColor("#171512");
    this.scene.start("Preload");
  }
}
